export default __webpack_public_path__ + "static/media/feedback-bad.39fd0cbd.png";